
import { defineComponent } from 'vue';
import TpxLabel from './label.vue';
import './checkbox.scss';

/**
  * Checkbox form field
  * 
  * @example
  * <code>import TpxCheckbox from '@manifesto-tech/tpximpact-design-system/components/atoms/form/checkbox.vue'</code>
  */
export default defineComponent({
  name: 'TpxCheckbox',

  components: {
    TpxLabel,
  },

  emits: [
    'change',
  ],

  mounted() {
    /** 
     * If url has a search parameter that matches the name and value of this checkbox, check this checkbox
    */
    const searchParams = new URLSearchParams(window.location.search);
    const activeSectorFilters = searchParams.getAll('Sector');
    const activeServiceFilters = searchParams.getAll('Service');
    const activeTopicFilters = searchParams.getAll('Topic');

    if (activeSectorFilters.includes(this.$props.value) && this.$props.name === 'Sector') {
      this.$props.isChecked = true;
    }
    else if (activeServiceFilters.includes(this.$props.value) && this.$props.name === 'Service') {
      this.$props.isChecked = true;
    }
    else if (activeTopicFilters.includes(this.$props.value) && this.$props.name === 'Topic') {
      this.$props.isChecked = true;
    }
    else {
      //do nothing
    }

  },

  props: {
    /**
     * ID of the form field
     */
    id: {
      required: true,
      type: String,
    },

    /**
     * Is the checkbox checked by default?
     */
    isChecked: {
      default: false,
      type: Boolean,
    },

    /**
     * Is the checkbox required?
     */
    isRequired: {
      type: Boolean,
    },

    /**
     * Label
     */
    label: {
      required: true,
      type: String,
    },

    /**
     * Name of the data field
     */
    name: {
      required: true,
      type: String,
    },

    /**
     * Value of the checkbox
     */
    value: {
      type: String,
    }
  },
});
